module.exports = __webpack_public_path__ + "img/ChartFilterAuswahl.28eba8c4.png";